import { isLassoAdmin } from "@/services/auth.service";
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/hidden")({
  beforeLoad: ({ context }) => {
    const { user } = context;
    if (
      !isLassoAdmin(user) &&
      !import.meta.env.DEV &&
      import.meta.env.MODE !== "staging"
    )
      throw notFound();
  },
  component: () => <Outlet />,
});
